import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { OrderTracking } from "../../components/OrderTracking";

const Container = styled.div`
  min-height: 100vh;
  padding: 2rem 0;
  background: #f8f9fa;
`;

const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const OrderDetail = () => {
  const { id } = useParams();

  return (
    <Container>
      <Content>
        <OrderTracking orderId={id} />
      </Content>
    </Container>
  );
};

export default OrderDetail;
